import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import api from "@/api";
import EmdEnumValueListView from "@/views/manager/EmdEnumValueListView.vue";
import ButtonDialog from "@/components/ButtonDialog.vue";
import DialogCustomView from "@/components/DialogCustomView.vue";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
export default {
  name: "SiteKeywordsListView",
  components: {
    BatterTableDataView,
    DialogCustomView,
    ButtonDialog,
    EmdEnumValueListView
  },
  data() {
    return {
      tab: '-',
      sites: [],
      selected: [],
      kwdId: null,
      viewRefArticles: false
    };
  },
  methods: {
    previewHtml(d) {
      window.open(`/html/preview/${d.htmlId}?footer=${d.footId ? d.footId : ''}&page=${d.id}`, '_blank');
    },
    showRefCnt(id) {
      this.kwdId = id;
      this.viewRefArticles = true;
    },
    openReplaceForm() {
      this.$refs.replaceForm.open();
    },
    onRowSelectChange(d) {
      this.selected = d.map(s => s.id);
    },
    init() {
      api.getEnumOptionList(4, true).then(ret => {
        this.sites = ret;
        this.tab = ret.length > 0 ? ret[0].label : '-';
      });
    }
  },
  mounted() {
    this.init();
  }
};